/**
 * @voltxampere/ui — DC Current Source (Akım Kaynağı)
 *
 * Closes the Class B gap from Sprint 25 R1 triage's
 * `TRIAGE_LANE4_FINDINGS.md` §2 — schema canonical
 * `current-source` had no UI symbol entry, so any preset or
 * stamp using it triggered the "No symbol registered" warning
 * (rendered nothing). This Sprint 25 R2 lane 4b adds the symbol.
 *
 * IEC convention: open circle with an upward arrow inside that
 * marks the conventional current direction. The `pos` terminal
 * sits at the top (current exits) and `neg` at the bottom
 * (current enters). Body sits on the same 40×26 viewBox as the
 * other vertical sources (`dc-source`, `ac-source`,
 * `pulse-source`) so vertical-rail layouts stay visually
 * consistent.
 *
 * v1 reference: `~/Desktop/VoltXAmpere/src/components/
 * definitions.js:133` `iac` (AC current). v1 has no dedicated DC
 * current source, so the geometry here is a fresh minimal IEC
 * rendering rather than a v1 port.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT } from "./constants.js";
export const currentSource = {
    id: "current-source",
    nameTr: "Akım Kaynağı",
    nameEn: "Current Source",
    shortcut: "I",
    category: "source",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 20, y: 3, label: "+", polarity: "out" },
        { x: 20, y: 23, label: "−", polarity: "in" },
    ],
    defaultLabel: "I",
    defaultValue: "1mA",
    renderSVG: () => [
        // Pin leads — top + bottom from circle edge to viewBox edge.
        `<line x1="20" y1="0" x2="20" y2="3" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="20" y1="23" x2="20" y2="26" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        // Body circle (radius 10, center 20,13).
        `<circle cx="20" cy="13" r="10" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        // Vertical arrow shaft inside the circle (current direction
        // upward — conventional current exits the `+` / pos pin).
        `<line x1="20" y1="19" x2="20" y2="7" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        // Arrow head at the top (open V).
        `<line x1="20" y1="7" x2="17" y2="11" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="20" y1="7" x2="23" y2="11" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=current-source.js.map